module.exports = __webpack_public_path__ + "img/zhigong.2671f0e6.png";